import './story-spokespeople.scss';

import StorySpokespeople from './StorySpokespeople';

export default StorySpokespeople;
